<template>
  <div class="search-form">
    <b-row align-h="between">
      <b-col cols="9">
        <b-form @reset="reset" onsubmit="return false">
          <b-input-group size="sm">
            <b-button
              size="sm"
              class="ml-2"
              variant="outline-success"
              @click="add()"
              v-show="addButtonVisible"
              v-if="allow('A')"
            >
              <b-icon-plus></b-icon-plus>
              {{ $l('INDEX.btn_add') || '新增' }}
            </b-button>
            <el-badge
              v-show="addButtonVisible"
              :value="checkedCount"
              class="ml-2"
              v-if="allow('C')"
            >
              <b-button
                size="sm"
                variant="outline-success"
                @click="() => $emit('openCopyDialog')"
                v-show="addButtonVisible"
                :disabled="!checkedCount"
                v-if="allow('C')"
              >
                <b-icon-plus></b-icon-plus>
                {{ $l('INDEX.btn_copy') || '拷贝' }}
              </b-button>
            </el-badge>
          </b-input-group>
        </b-form>
      </b-col>
    </b-row>
  </div>
</template>

<script>
// 初始表单
const initForm = {
  keyword: '',
}

export default {
  props: {
    checkedCount: { type: Number, default: 0 },
    // depRow: {
    //   type: Object,
    //   default: () => {},
    // },
  },
  data() {
    return {
      advqueryDialogVisible: false,
      form: { ...initForm },
      orgRow: {},
      addButtonVisible: false,
    }
  },
  created() {
    this.query()
  },
  methods: {
    fromLoad(val) {
      this.$emit(val)
    },
    orgChange(row) {
      this.orgRow = row
      this.addButtonVisible = row.classLevel == 1
      this.query()
    },
    // 初始查询
    query({ isReset = true } = {}) {
      if (isReset) {
        this.$emit('reset')
      }
      this.$emit('query', {
        ...this.form,
        sampleCategoryCode: this.orgRow.categoryCode,
        productLine: this.orgRow.productLine,
      })
    },
    // 高级查询
    advquery() {
      this.form.keyword = ''
      this.query()
      this.closeAdvqueryDialog()
    },
    // 重置查询条件 - 高级查询
    reset() {
      this.form = { ...initForm }
    },
    // 打开高级查询
    openAdvqueryDialog() {
      this.advqueryDialogVisible = true
    },
    // 关闭高级查询
    closeAdvqueryDialog() {
      this.advqueryDialogVisible = false
    },
    add() {
      let classLevl = this.orgRow.classLevel
      if (classLevl != 1) {
        this.$message.warning('请先选择一个二级分类！')
        return
      }
      this.$emit('openEditFormDialog', { type: 'add' })
    },
  },
}
</script>
<style lang="scss" scoped>
.el-form-item {
  margin-bottom: 0px;
}
.line {
  text-align: center;
}
</style>
